import useStores from '$src/hooks/useStores';

export default function useFeature(featureName, waitForAllDomains) {
  const { sessionStore } = useStores();
  const { allDomainsConsulted, featureFlags, isLoading } = sessionStore;
  const isFeatureActive = featureFlags?.[featureName]?.enabled ?? false;

  return [waitForAllDomains && !allDomainsConsulted ? true : isFeatureActive || featureFlags === null, isLoading];
}
